export default __webpack_public_path__ + "static/media/htbabyImg5.1b05c648.png";